import { ModuleCreatorAction, ModuleCreatorActionType } from '../_actions/ModuleCreatorActions';
import ModuleCreatorStore from '../_stores/ModuleCreatorStore';

const ModuleCreatorReducer = (store:ModuleCreatorStore = new ModuleCreatorStore(), action: ModuleCreatorAction):ModuleCreatorStore => {
	switch (action.type) {
		case ModuleCreatorActionType.OnModuleCreatorOpen:
			store = store.set('opened', true);

			if(action.category) {
				store = store.set('category', action.category);
			}

			return store;
		case ModuleCreatorActionType.OnModuleCreatorOpenToggle:
			let opened = store.get('opened');
			store = store.set('opened', !opened);

			return store;

		case ModuleCreatorActionType.OnModuleCreatorClose:
			return store.set('opened', false);

		case ModuleCreatorActionType.OnModuleCreatorSearch:
			return store.set('search', action.value);

		case ModuleCreatorActionType.OnModuleCreatorCategory:
			return store.set('category', action.value);
	}

	return store;
}

export default ModuleCreatorReducer